var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('HeaderTop'),_c('MenuPage'),_c('BannerDetail',{attrs:{"backgroundImage":require('../assets/img/banner11.jpg'),"title":_vm.$t('newbannertitle'),"description":_vm.$t('newbannerdescription')}}),_c('div',{staticClass:"new-main"},[_c('NewItem')],1),_c('div',{staticClass:"footer-main"},[_vm._v(" "+_vm._s(_vm.$t("footertitile"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }